export default __webpack_public_path__ + "static/barcelona-view-f3b663ae3be517db7b8666e485b0d3c1.jpg";